// ToastContext.js
import { Toast } from "primereact/toast";
import { createContext, useContext, useRef } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toastRef = useRef(null);

  const showToast = (toastOptions) => {
    toastRef.current.show({
      severity: toastOptions.severity,
      summary: toastOptions.summary,
      detail: toastOptions.detail,
      life: toastOptions.duration ?? 2000,
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toast ref={toastRef} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
